import * as S from './style';

import DeliveryHeaderComponent from './components/DeliveryHeaderComponent';
import DeliveryExpectTimeComponent from './components/DeliveryExpectTimeComponent';
import DeliveryInvoiceInfoComponent from './components/DeliveryInvoiceInfoComponent';
import DeliveryProgressComponent from './components/DeliverProgressComponent';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { baseAPI } from 'api/instance';
import { useEffect, useRef, useState } from 'react';
import S3ImagePopUp from './components/S3ImagePopUp';
import DeliveryMap from './components/DeliveryMap';
import { getMessageDelivery, TResponseGetMessageDelivery } from './api';
import DeliverProgressComponentWrapper from './components/DeliverprogressComponentWrapper';

export default function Delivery() {
  const id = useParams().id;
  const [s3Image, setS3Image] = useState('');

  const {
    data,
    isLoading,
    refetch: deliveryInfoRefetch,
  } = useQuery({
    queryKey: ['getMessageDelivery', id],
    queryFn: async () => {
      if (id) {
        const res = await getMessageDelivery({ encryptId: id });
        if (!!res) {
          const progressStatus = {
            completed: { step: '주문 처리 완료', status: '처리 완료', date: '' },
            arrived: { step: '도착 예정', status: '이동중', date: '' },
            processing: { step: '기사님 출발', status: '이동중', date: '' },
            scheduled: { step: '출발 예정', status: '작업 대기', date: '' },
          };
          res.history.forEach(history => {
            switch (history.type) {
              case 'completed':
                progressStatus.completed = {
                  step: '주문 처리 완료',
                  status: '처리 완료',
                  date: history.createdAt ?? '',
                };
                break;
              case 'processing':
                progressStatus.arrived = { step: '도착 예정', status: '이동중', date: history.createdAt ?? '' };
                break;
              case 'scheduled':
                progressStatus.processing = { step: '기사님 출발', status: '이동중', date: history.createdAt ?? '' };
                break;
              case 'routueRegist':
                progressStatus.scheduled = { step: '출발 예정', status: '작업 대기', date: history.createdAt ?? '' };
                break;
            }
          });
          let now = res?.orderInfo?.status ?? '';
          let orderStatus = res?.orderInfo?.status ?? '';
          if (res?.orderInfo?.status === 'processing') {
            now = 'arrived';
            orderStatus = 'arrived';
          }else if (res?.orderInfo?.status === 'scheduled'){
            now = 'processing';
            orderStatus = 'processing';
          }
            return {
              invoiceInfo: {
                name: res?.orderInfo?.order.consigneeName ?? '',
                address: res.orderInfo.order.address ?? '',
                driver: res.orderInfo.driver.name ?? '',
                driverId: res?.orderInfo?.driver.driverId ?? null,
              },
              progressStatus: progressStatus,
              eta: res?.orderInfo?.eta ?? '',
              now,
              s3Files: res?.s3Files ?? [],
              destinationCoordinate: res?.orderInfo?.order?.coordinate?.coordinates ?? [],
              orderStatus,
            };
        }
        return null;
      }
    },
    onError: err => {
      console.log(err);
    },
    refetchInterval: 1000 * 60 * 5,
  });

  if (isLoading || !data || !id || !data?.invoiceInfo?.driverId) return <></>;
  return (
    <S.Container>
      <S3ImagePopUp setS3Image={setS3Image} s3Image={s3Image} />
      <S.BodyContainer>
        {/* <DeliveryHeaderComponent /> */}
        <DeliveryExpectTimeComponent
          now={data?.now}
          eta={data?.eta}
          deliveryInfoRefetch={deliveryInfoRefetch}
          progressStatus={data.progressStatus}
        />
        <DeliveryInvoiceInfoComponent
          address={data?.invoiceInfo.address}
          name={data?.invoiceInfo.name}
          driver={data?.invoiceInfo.driver}
        />
        <DeliveryMap
          encryptId={id}
          driverId={data?.invoiceInfo?.driverId}
          orderStatus={data?.orderStatus}
          // encryptId={'4099634fa0d1253cc8be25280a51f0a9260114c4d52c280e5dec338101f63d87b99c03ec38c2c27408e3f797c24a1a0a'}
          // driverId={132}
          // orderStatus={'processing'}
          destinationCordinates={data?.destinationCoordinate}
        />
        <DeliveryProgressComponent
          now={data?.now}
          progressStatus={data?.progressStatus}
          s3Files={data?.s3Files}
          setS3Image={setS3Image}
        />
        {/* <DeliverProgressComponentWrapper
          now={data?.now}
          progressStatus={data?.progressStatus}
          s3Files={data?.s3Files}
          setS3Image={setS3Image}
        /> */}
      </S.BodyContainer>
    </S.Container>
  );
}
